import axios from 'axios'
import miniToastr from 'mini-toastr'
// import moment from 'moment'
import {
  format,
  startOfMonth, endOfMonth
} from 'date-fns'
// import Vue from 'vue';
import {EventBus} from "../../../event-bus.js";

import configAll from '../../../../config/index.cjs'

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']

const API_URL = config.urlServer
const GET_URL = `${API_URL}api/per/ficat/`
const CATECO_URL = `${API_URL}api/per/ficateco/`
const ADD_URL = `${API_URL}api/per/fitable/`
const FIECO_URL = `${API_URL}api/per/fieco/`
const BUDGET_URL = `${API_URL}api/per/budget/`
const RECURRING_URL = `${API_URL}api/per/firecurrent/`
const PLANNING_URL = `${API_URL}api/per/fiplanning/`
const FIRECANNUALLY_URL = `${API_URL}api/per/firecannually/`

export default {
  namespaced: true,
  state: {
    categories: [],
    cateco: [],
    items: [],
    itemseco: [],
    recurrent: [],
    subtotal_personal: 0,
    subtotal_business: 0,
    datacollection: {},
    leftItems: [],
    rightItems: [],
    dates: [],
    dateseco: [],
    budgets: [],
    budgetData: {},
    plannings: [],
    planningsAll: [],
    plannings1: {},
    planningDone: [],
    planningNext: [],
    totalPlanningItems: 0,
    recurrences: [],
    availableRec: [],
    itemsRec: [],
    recTypes: [],
  },
  mutations: {
    setRecTypes(state, opts) {
      let usedRecurrentItems = [];
      let leftRecurrentTypes = [];
      // eslint-disable-next-line
      for (let [key, value] of Object.entries(state.itemsRec)) {
        value.forEach((item) => {
          if (item.checked === true) {
            usedRecurrentItems.push(item.id)
          } else {
            if (!leftRecurrentTypes.includes(key)) {
              leftRecurrentTypes.push(key);
            }

          }
        })
      }
      let hh = [];
      leftRecurrentTypes.forEach((item) => {
        const ii = opts.recTypes.find((rec) => rec.key === item);
        if (ii) {
          const index = opts.recTypes.indexOf(ii)
          if (index > -1) {
            hh.push(opts.recTypes[index]);
          }
        }
      });
      if (!leftRecurrentTypes.includes(opts.include_type) && opts.include_type.length) {
        const ii = opts.recTypes.find((rec) => rec.key === opts.include_type);
        if (ii) {
          const index = opts.recTypes.indexOf(ii)
          if (index > -1) {
            hh.push(opts.recTypes[index]);
          }
        }
      }
      state.recTypes = hh;
    },
    setAvailableRecurrency(state, opts) {
      let leftRecurrentItems = [];
      // eslint-disable-next-line
      for (let [key, value] of Object.entries(state.itemsRec)) {
        if (key == opts.type) {
          value.forEach((item) => {
            if (item.checked === false || item.id === opts.item) {
              leftRecurrentItems.push(item)
            }
          })
        }

      }
      state.availableRec = leftRecurrentItems;
    },
    setCatEco (state, items) {
      // console.log(items.yearEco);
      // eslint-disable-next-line
      const cc = items.cats;
      cc.forEach((cc1) => {
        // eslint-disable-next-line
        cc1.cumulated_amount = 0;
      })
      // state.cateco = items.cats;
      const catIds = []
      const bb = items.yearEco.reduce((memo, item) => {
        // eslint-disable-next-line
        item.amount = parseFloat(item.amount);
        const key = item.cat_id
        // eslint-disable-next-line
        if (!memo[key]) {
          // eslint-disable-next-line
          memo[key] = { name: item.FiCatEco.name, color: item.FiCatEco.color, amount: item.amount };
        } else {
          // eslint-disable-next-line
          memo[key].amount = parseFloat(memo[key].amount) + parseFloat(item.amount);
        }
        if (!catIds.includes(key)) {
          catIds.push(key)
        }
        return memo
      }, {})
      cc.forEach((cc12) => {
        if (bb[cc12.id]) {
          // eslint-disable-next-line
          cc12.cumulated_amount = parseFloat(bb[cc12.id].amount);
        }
      })

      // eslint-disable-next-line
      state.cateco = cc;
    },
    setCat (state, items) {
      // eslint-disable-next-line
      state.categories = items;
    },
    addRecurrency(state, item) {
      state.recurrences.push(item)
    },
    setRecurrency (state, items) {
      // eslint-disable-next-line
      state.recurrences = items;
    },
    setCurrentMonth (state, items) {
      // eslint-disable-next-line
      state.dates = [];
      // eslint-disable-next-line
      state.items = [];
      // eslint-disable-next-line
      state.recurrent = [];
      // eslint-disable-next-line
      state.subtotal_personal = 0;
      // eslint-disable-next-line
      state.subtotal_business = 0;
      const aa = items
      // const dates = [];
      const bb = aa.reduce((memo, item) => {
        // eslint-disable-next-line
        // console.log(moment(item.date));
        // eslint-disable-next-line
        item.price = parseFloat(item.price);
        const key = format(new Date(item.date),'dd-MM-yyyy')
        // eslint-disable-next-line
        memo[key] = memo[key] || [];
        // eslint-disable-next-line
        // item.date = moment(item.date);
        memo[key].push(item)
        if (!state.dates.includes(key)) {
          state.dates.push(key)
        }
        return memo
      }, {})

      const cc1 = aa.reduce((memo, item) => {
        const key = item.recurrent_type
        if (key) {
          // eslint-disable-next-line
          memo[key] = memo[key] || [];
          // eslint-disable-next-line
          memo[key].push(item);
        }
        return memo
      }, {})

      const dd1 = aa.reduce((memo, item) => {
        // eslint-disable-next-line
        // console.log(item.price);
        if (item.FiCat.color !== '#7c5ac2') {
          // eslint-disable-next-line
          memo +=  parseFloat(item.price);
        }
        return memo
      }, 0)

      const dd2 = aa.reduce((memo, item) => {
        // eslint-disable-next-line
        // console.log(item);
        if (item.FiCat.color === '#7c5ac2') {
          // eslint-disable-next-line
          memo +=  parseFloat(item.price);
        }
        return memo
      }, 0)

      const dd = []
      state.dates.forEach((date) => {
        const cc = {}
        // eslint-disable-next-line
        // console.log(moment(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS')));
        // eslint-disable-next-line
        // console.log(bb[date]);
        cc[date] = bb[date]
        dd.push(cc)
      })

      // eslint-disable-next-line
      // console.log(dd);

      // eslint-disable-next-line
      state.items = dd;
      // eslint-disable-next-line
      state.recurrent = cc1;

      // eslint-disable-next-line
      state.subtotal_personal = dd1;

      // eslint-disable-next-line
      state.subtotal_business = dd2;
      // context.items = [{
      //   '2018-05-09':
      // [{description:'aa', price:10},
      // {description: 'dd', price:23}, {description:'cc', price: 14}]
      // },
      //   {'2018-05-10':[{description: 'bb', price: 15}]}
      //   ];
    },
    setItem (state, item) {
      const key = format(new Date(item.date), 'dd-MM-yyyy')
      // eslint-disable-next-line
      item.price = parseFloat(item.price);
      // state.items.push(item);
      let exists = true
      if (!state.dates.includes(key)) {
        state.dates.push(key)
        exists = false
      }
      if (exists) {
        const findItem = state.items.find(item1 => Object.keys(item1)[0] === key)
        if (findItem) {
          const index = state.items.indexOf(findItem)
          if (index > -1) {
            state.items[index][key].push(item)
          }
        }
      } else {
        const cc = {}
        cc[key] = [item]
        state.items.push(cc)
      }
      if (item.flag_recurrent) {
        if (state.recurrent[item.recurrent_type]) {
          state.recurrent[item.recurrent_type].push(item)
        } else {
          // eslint-disable-next-line
          state.recurrent[item.recurrent_type] = [item];
        }
      }
      if (item.FiCat.color !== '#7c5ac2') {
        // eslint-disable-next-line
        state.subtotal_personal = state.subtotal_personal + item.price;
      } else {
        // eslint-disable-next-line
        state.subtotal_business = state.subtotal_business + item.price;
      }
    },
    editItem (state, obj) {
      const itemNew = obj.item
      const itemOld = obj.oldItem
      const newRecItem = obj.newRecItem
      const newRecType = obj.newRecType
      const oldRecItem = obj.oldItem.recurrent_item ?? ''
      const oldRecType = obj.oldItem.recurrent_type ?? ''

      itemOld.price = parseFloat(itemOld.price)
      itemNew.price = parseFloat(itemNew.price)
      if (itemOld.FiCat.color !== '#7c5ac2') {
        // eslint-disable-next-line
        state.subtotal_personal = state.subtotal_personal - itemOld.price;
      } else {
        // eslint-disable-next-line
        state.subtotal_business = state.subtotal_business - itemOld.price;
      }
      if (itemNew.FiCat.color !== '#7c5ac2') {
        // eslint-disable-next-line
        state.subtotal_personal = state.subtotal_personal + itemNew.price;
      } else {
        // eslint-disable-next-line
        state.subtotal_business = state.subtotal_business + itemNew.price;
      }
      /*if (itemOld.flag_recurrent && !itemNew.flag_recurrent) {
        // eslint-disable-next-line
        const findItem = state.recurrent[itemOld.recurrent_type].find((item1) => item1.id === itemOld.id);
        if (findItem) {
          const index = state.recurrent[itemOld.recurrent_type].indexOf(findItem)
          if (index > -1) {
            state.recurrent[itemOld.recurrent_type].splice(index, 1)
          }
        }
      }
      if (!itemOld.flag_recurrent && itemNew.flag_recurrent) {
        if (state.recurrent[itemNew.recurrent_type]) {
          state.recurrent[itemNew.recurrent_type].push(itemNew)
        } else {
          // eslint-disable-next-line
          state.recurrent[itemNew.recurrent_type] = [itemNew];
        }
      }
      // eslint-disable-next-line
      if (itemOld.flag_recurrent && itemNew.flag_recurrent && itemOld.recurrent_type !== itemNew.recurrent_type) {
        // eslint-disable-next-line
        const findItem = state.recurrent[itemOld.recurrent_type].find((item1) => item1.id === itemOld.id);
        if (findItem) {
          const index = state.recurrent[itemOld.recurrent_type].indexOf(findItem)
          if (index > -1) {
            state.recurrent[itemOld.recurrent_type].splice(index, 1)
          }
        }
        if (state.recurrent[itemNew.recurrent_type]) {
          state.recurrent[itemNew.recurrent_type].push(itemNew)
        } else {
          // eslint-disable-next-line
          state.recurrent[itemNew.recurrent_type] = [itemNew];
        }
      }*/

      if (itemOld.flag_recurrent && !itemNew.flag_recurrent) {
        if (oldRecType.length) {
          const findItem = state.itemsRec[oldRecType].find((item1) => item1.id === oldRecItem);
          // console.log(findItem)
          if (findItem) {
            const index = state.itemsRec[oldRecType].indexOf(findItem)
            if (index > -1) {
              state.itemsRec[oldRecType][index].checked = false
            }
          }
        }

      }
      if (!itemOld.flag_recurrent && itemNew.flag_recurrent) {
        if (newRecType.length) {
          const findItem = state.itemsRec[newRecType].find((item1) => item1.id === newRecItem);
          if (findItem) {
            const index = state.itemsRec[newRecType].indexOf(findItem)
            if (index > -1) {
              state.itemsRec[newRecType][index].checked = true
            }
          }
        }
      }
      // // eslint-disable-next-line
      if (itemOld.flag_recurrent && itemNew.flag_recurrent && (oldRecType !== newRecType || oldRecItem !== newRecItem)) {
        // eslint-disable-next-line
        if (oldRecType.length) {
          const findItem = state.itemsRec[oldRecType].find((item1) => item1.id === oldRecItem);
          // console.log(findItem)
          if (findItem) {
            const index = state.itemsRec[oldRecType].indexOf(findItem)
            if (index > -1) {
              state.itemsRec[oldRecType][index].checked = false
            }
          }
        }

        if (newRecType.length) {
          const findItem1 = state.itemsRec[newRecType].find((item1) => item1.id === newRecItem);
          if (findItem1) {
            const index = state.itemsRec[newRecType].indexOf(findItem1)
            if (index > -1) {
              state.itemsRec[newRecType][index].checked = true
            }
          }
        }
      }
      const keyDateOld = format(new Date(itemOld.date), 'dd-MM-yyyy')
      const keyDateNew = format(new Date(itemNew.date), 'dd-MM-yyyy')
      if (keyDateOld !== keyDateNew) {
        const findItem = state.items.find(item1 => Object.keys(item1)[0] === keyDateOld)
        if (findItem) {
          const index = state.items.indexOf(findItem)
          if (index > -1) {
            const findAa = state.items[index][keyDateOld].find(item1 => item1.id === itemOld.id)
            if (findAa) {
              const index1 = state.items[index][keyDateOld].indexOf(findAa)
              if (index1 > -1) {
                state.items[index][keyDateOld].splice(index1, 1)
              }
            }
          }
        }
        let exists = true
        if (!state.dates.includes(keyDateNew)) {
          state.dates.push(keyDateNew)
          exists = false
        }
        if (exists) {
          const findItem1 = state.items.find(item1 => Object.keys(item1)[0] === keyDateNew)
          if (findItem1) {
            const index = state.items.indexOf(findItem1)
            if (index > -1) {
              state.items[index][keyDateNew].push(itemNew)
            }
          }
        } else {
          const cc = {}
          cc[keyDateNew] = [itemNew]
          state.items.push(cc)
        }
      } else {
        // eslint-disable-next-line
        if (itemOld.FiCat.id !== itemNew.FiCat.id) {
          const findItem = state.items.find(item1 => Object.keys(item1)[0] === keyDateOld)
          if (findItem) {
            const index = state.items.indexOf(findItem)
            if (index > -1) {
              const findAa = state.items[index][keyDateOld].find(item1 => item1.id === itemOld.id)
              if (findAa) {
                const index1 = state.items[index][keyDateOld].indexOf(findAa)
                if (index1 > -1) {
                  // eslint-disable-next-line
                  state.items[index][keyDateOld][index1].FiCat = itemNew.FiCat;
                }
              }
            }
          }
        }
      }
    },
    setCurrentEco (state, items) {
      // eslint-disable-next-line
      state.dateseco = [];
      // eslint-disable-next-line
      state.itemseco = [];
      // eslint-disable-next-line
      // state.subtotal_personal = 0;
      // eslint-disable-next-line
      // state.subtotal_business = 0;
      const aa = items
      // const dates = [];
      const bb = aa.reduce((memo, item) => {
        // eslint-disable-next-line
        // console.log(moment(item.date));
        // eslint-disable-next-line
        item.amount = parseFloat(item.amount);
        const key = format(new Date(item.date), 'dd-MM-yyyy')
        // eslint-disable-next-line
        memo[key] = memo[key] || [];
        // eslint-disable-next-line
        // item.date = moment(item.date);
        memo[key].push(item)
        if (!state.dateseco.includes(key)) {
          state.dateseco.push(key)
        }
        return memo
      }, {})

      // const dd1 = aa.reduce((memo, item) => {
      //   // eslint-disable-next-line
      //   // console.log(item.price);
      //   if (item.FiCat.color !== '#7c5ac2') {
      //     // eslint-disable-next-line
      //     memo +=  parseFloat(item.price);
      //   }
      //   return memo;
      // }, 0);
      //
      // const dd2 = aa.reduce((memo, item) => {
      //   // eslint-disable-next-line
      //   // console.log(item);
      //   if (item.FiCat.color === '#7c5ac2') {
      //     // eslint-disable-next-line
      //     memo +=  parseFloat(item.price);
      //   }
      //   return memo;
      // }, 0);

      const dd = []
      state.dateseco.forEach((date) => {
        const cc = {}
        // eslint-disable-next-line
        // console.log(moment(moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS')));
        // eslint-disable-next-line
        // console.log(bb[date]);
        cc[date] = bb[date]
        dd.push(cc)
      })

      // eslint-disable-next-line
      // console.log(dd);

      // eslint-disable-next-line
      state.itemseco = dd;
      // eslint-disable-next-line
      // state.recurrent = cc1;

      // eslint-disable-next-line
      // state.subtotal_personal = dd1;

      // eslint-disable-next-line
      // state.subtotal_business = dd2;
      // context.items = [{
      //   '2018-05-09':
      // [{description:'aa', price:10},
      // {description: 'dd', price:23}, {description:'cc', price: 14}]
      // },
      //   {'2018-05-10':[{description: 'bb', price: 15}]}
      //   ];
    },
    setItemEco (state, item) {
      const key = format(new Date(item.date), 'dd-MM-yyyy')
      // eslint-disable-next-line
      item.amount = parseFloat(item.amount);
      // state.items.push(item);
      let exists = true
      if (!state.dateseco.includes(key)) {
        state.dateseco.push(key)
        exists = false
      }
      if (exists) {
        const findItem = state.itemseco.find(item1 => Object.keys(item1)[0] === key)
        if (findItem) {
          const index = state.itemseco.indexOf(findItem)
          if (index > -1) {
            state.itemseco[index][key].push(item)
          }
        }
      } else {
        const cc = {}
        cc[key] = [item]
        state.itemseco.push(cc)
      }
      // if (item.FiCat.color !== '#7c5ac2') {
      //   // eslint-disable-next-line
      //   state.subtotal_personal = state.subtotal_personal + item.price;
      // } else {
      //   // eslint-disable-next-line
      //   state.subtotal_business = state.subtotal_business + item.price;
      // }
    },
    editItemEco (state, obj) {
      const itemNew = obj.item
      const itemOld = obj.oldItem
      itemOld.amount = parseFloat(itemOld.amount)
      itemNew.amount = parseFloat(itemNew.amount)
      // if (itemOld.FiCat.color !== '#7c5ac2') {
      //   // eslint-disable-next-line
      //   state.subtotal_personal = state.subtotal_personal - itemOld.price;
      // } else {
      //   // eslint-disable-next-line
      //   state.subtotal_business = state.subtotal_business - itemOld.price;
      // }
      // if (itemNew.FiCat.color !== '#7c5ac2') {
      //   // eslint-disable-next-line
      //   state.subtotal_personal = state.subtotal_personal + itemNew.price;
      // } else {
      //   // eslint-disable-next-line
      //   state.subtotal_business = state.subtotal_business + itemNew.price;
      // }
      const keyDateOld = format(new Date(itemOld.date), 'dd-MM-yyyy')
      const keyDateNew = format(new Date(itemNew.date), 'dd-MM-yyyy')
      if (keyDateOld !== keyDateNew) {
        const findItem = state.itemseco.find(item1 => Object.keys(item1)[0] === keyDateOld)
        if (findItem) {
          const index = state.itemseco.indexOf(findItem)
          if (index > -1) {
            const findAa = state.itemseco[index][keyDateOld].find(item1 => item1.id === itemOld.id)
            if (findAa) {
              const index1 = state.itemseco[index][keyDateOld].indexOf(findAa)
              if (index1 > -1) {
                state.itemseco[index][keyDateOld].splice(index1, 1)
              }
            }
          }
        }
        let exists = true
        if (!state.dateseco.includes(keyDateNew)) {
          state.dateseco.push(keyDateNew)
          exists = false
        }
        if (exists) {
          const findItem1 = state.itemseco.find(item1 => Object.keys(item1)[0] === keyDateNew)
          if (findItem1) {
            const index = state.itemseco.indexOf(findItem1)
            if (index > -1) {
              state.itemseco[index][keyDateNew].push(itemNew)
            }
          }
        } else {
          const cc = {}
          cc[keyDateNew] = [itemNew]
          state.itemseco.push(cc)
        }
      } else {
        // eslint-disable-next-line
        if (itemOld.FiCatEco.id !== itemNew.FiCatEco.id) {
          const findItem = state.itemseco.find(item1 => Object.keys(item1)[0] === keyDateOld)
          if (findItem) {
            const index = state.itemseco.indexOf(findItem)
            if (index > -1) {
              // eslint-disable-next-line
              const findAa = state.itemseco[index][keyDateOld].find(item1 => item1.id === itemOld.id);
              if (findAa) {
                const index1 = state.itemseco[index][keyDateOld].indexOf(findAa)
                if (index1 > -1) {
                  // eslint-disable-next-line
                  state.itemseco[index][keyDateOld][index1].FiCatEco = itemNew.FiCatEco;
                }
              }
            }
          }
        }
      }
    },
    setStats (state, items) {
      const aa = items
      const catIds = []
      const bb = aa.reduce((memo, item) => {
        // eslint-disable-next-line
        item.price = parseFloat(item.price);
        const key = item.cat_id
        // eslint-disable-next-line
        if (!memo[key]) {
          // eslint-disable-next-line
          memo[key] = { name: item.FiCat.name, color: item.FiCat.color, price: item.price };
        } else {
          // eslint-disable-next-line
          memo[key].price = memo[key].price + item.price;
        }
        if (!catIds.includes(key)) {
          catIds.push(key)
        }
        return memo
      }, {})
      // console.log(bb);

      const dd = []
      catIds.forEach((catId) => {
        let cc = []
        cc = bb[catId]
        dd.push(cc)
      })

      dd.sort((a, b) => a.price - b.price).reverse()

      const dd1 = []
      const dd2 = []
      dd.forEach((item, k) => {
        if (k % 2 === 0) {
          dd1.push(item)
        } else {
          dd2.push(item)
        }
      })

      const names = dd.map(item => `${item.name}`) // - ${Vue.filter('formatPrice')(item.price)}
      // eslint-disable-next-line
      const colors = dd.map(item => item.color);
      // eslint-disable-next-line
      const prices = dd.map(item => item.price);

      // eslint-disable-next-line
      state.datacollection = {
        labels: names,
        datasets: [
          {
            data: prices,
            borderWidth: 0,
            backgroundColor: colors
          }]
      }
      // eslint-disable-next-line
      state.leftItems = dd1;
      // eslint-disable-next-line
      state.rightItems = dd2;
    },
    setBudgets (state, items) {
      // eslint-disable-next-line
      state.budgets = items;
    },
    setBudgetData (state, items) {
      const budgets = []
      state.datacollection.labels.forEach((item2) => {
        items.forEach((item) => {
          if (item2 === item.FiCat.name) {
            budgets.push(parseInt(item.amount, 10))
          }
        })
      })
      const cc = []
      budgets.forEach((item, k) => {
        cc.push(item - state.datacollection.datasets[0].data[k])
      })
      // eslint-disable-next-line
      state.budgetData = {
        labels: state.datacollection.labels,
        datasets: [
          {
            label: 'Budget',
            backgroundColor: '#f87979',
            data: budgets
          },
          {
            label: 'Spent',
            backgroundColor: '#cccccc',
            data: state.datacollection.datasets[0].data
          },
          {
            label: 'Remaining',
            backgroundColor: '#9fdaad',
            data: cc
          }
        ]
      }
    },
    setPlanning (state, item) {
      // eslint-disable-next-line
      const findItem = state.plannings.find(item1 => Object.keys(item1)[0] == item.cat_id);
      if (findItem) {
        const index = state.plannings.indexOf(findItem)
        if (index > -1) {
          // eslint-disable-next-line
          item.cost_estimate = parseFloat(item.cost_estimate);
          state.plannings[index][item.cat_id].items.push(item)
        }
      }
    },
    editPlanning (state, obj) {
      const itemNew = obj.item
      const itemOld = obj.oldItem
      // console.log(itemNew);
      itemOld.cost_estimate = parseFloat(itemOld.cost_estimate)
      itemNew.cost_estimate = parseFloat(itemNew.cost_estimate)
      if (itemOld.cat_id !== itemNew.cat_id) {
        // eslint-disable-next-line
        const findItem = state.plannings.find(item1 => Object.keys(item1)[0] == itemOld.cat_id);
        // console.log(findItem);
        if (findItem) {
          const index = state.plannings.indexOf(findItem)
          if (index > -1) {
            // eslint-disable-next-line
            const findAa = state.plannings[index][itemOld.cat_id].items.find(item1 => item1.id === itemOld.id);
            // console.log(findAa);
            if (findAa) {
              const index1 = state.plannings[index][itemOld.cat_id].items.indexOf(findAa)
              // console.log(index1);
              if (index1 > -1) {
                state.plannings[index][itemOld.cat_id].items.splice(index1, 1)
              }
            }
          }
        }
        // eslint-disable-next-line
        const findItem1 = state.plannings.find(item1 => Object.keys(item1)[0] == itemNew.cat_id);
        if (findItem1) {
          const index = state.plannings.indexOf(findItem1)
          if (index > -1) {
            state.plannings[index][itemNew.cat_id].items.push(itemNew)
          }
        }
      }
    },
    setPlannings (state, items) {
      // eslint-disable-next-line
      state.planningsAll = items.rows;
      const catIds = []
      const bb = items.rows.reduce((memo, item) => {
        // eslint-disable-next-line
        item.cost_estimate = parseFloat(item.cost_estimate);
        // eslint-disable-next-line
        memo[item.FiCat.id] = memo[item.FiCat.id] || [];
        memo[item.FiCat.id].push(item)
        return memo
      }, {})
      const aa = []
      Object.keys(bb).forEach((key) => {
        const item = {}
        item[key] = {
          name: bb[key][0].FiCat.name,
          items: bb[key]
        }
        item.cat_id = key
        catIds.push(parseInt(key, 10))
        aa.push(item)
      })
      // console.log(bb);

      state.categories.forEach((cat) => {
        // console.log(cat);
        if (!catIds.includes(cat.id)) {
          const item = {}
          item[cat.id] = {
            name: cat.name,
            items: []
          }
          item.cat_id = cat.id
          aa.push(item)
        }
      })
      // eslint-disable-next-line
      state.plannings = aa;
      // eslint-disable-next-line
      state.plannings1 = bb;
      // eslint-disable-next-line
      state.totalPlanningItems = items.count;

      // console.log(aa);

      // context.items = [{
      //   1:
      // [{id:1, cat_id:1, ...},
      // {id:2, cat_id:1, ...}]
      // },
      //   {'2':[{id: 3, cat_id: 2}]}
      //   ];
    },
    setPlanningDone (state, items) {
      // eslint-disable-next-line
      state.planningDone = items;
    },
    setPlanningNext (state, items) {
      // eslint-disable-next-line
      state.planningNext = items;
    },
    setCurrentRecurrency(state, items) {
      let rec = items.rec;
      let financialRows = items.financialRows;
      let annuallyPaid = items.annuallyPaid;
      // let startDate = items.startDate;
      let endDate = items.endDate;
      let bbb = [];
      financialRows.forEach((item) => {
        item.FiRecurrencies.forEach((itemFi) => {
          // console.log(item);
          if (itemFi) {
            bbb.push(itemFi.id);
          }
        })
      });
      annuallyPaid.forEach((item) => {
        item.FiRecurrencies.forEach((itemFi) => {
          if (itemFi && !bbb.includes((itemFi.id))) {
            bbb.push(itemFi.id);
          }
        })
      });

      let types = [];
      let aaa = {};

      let currentRec = [];
      rec.forEach((item) => {
        let shouldStay = false;
        item.FiRecurrentActives.forEach((itemAct) => {
          //console.log(itemAct);
          if ((new Date(itemAct.date_start)) <= endDate && endDate <= (new Date(itemAct.date_end)) ) {
            shouldStay = true;
          }
        })
        if (shouldStay) {
          currentRec.push(item);
        }
      })

      currentRec.forEach((item) => {
        item.checked = false
        if (bbb.includes(item.id)) {
          item.checked = true
        }
        if (types.includes(item.type)) {
          aaa[item.type].push(item);
        } else {
          aaa[item.type] = [item];
          types.push(item.type);
        }
      })
      state.itemsRec = aaa;
    },
    addCatFinancial(state, item) {
      state.categories.push(item)
    }
  },
  actions: {
    getCatEco ({ commit }, year) {
      axios.all([
        axios.get(`${FIECO_URL}by?year=${year}`),
        axios.get(CATECO_URL)
      ])
        .then(axios.spread((yearEco, cats) => {
          commit('setCatEco', { cats: cats.data, yearEco: yearEco.data })
        })).catch((err) => {
        // eslint-disable-next-line
        miniToastr.error(err.response.data.errorMessage, 'Get Financial Year Economii or Cat Economii failed!', 1500);
        })
    },
    getCat ({ commit }) {
      axios.get(GET_URL)
        .then((response) => {
          commit('setCat', response.data)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Get Financial Categories failed!', 1500)
        })
    },
    getCurrentEco ({ commit }, obj) {
      const currentMonth = format(obj.date, 'MM')
      const currentYear = format(obj.date, 'yyyy')
      const startDate1 = new Date(`${currentYear}-${currentMonth}-01 00:00:00`)
      const startDate = format(startOfMonth(new Date(startDate1)), 'yyyy-MM-dd HH:mm:ss').toString()
      const endDate = format(endOfMonth(new Date(startDate1)), 'yyyy-MM-dd HH:mm:ss').toString()

      axios.get(`${FIECO_URL}?fromDate=${encodeURI(startDate)}&endDate=${encodeURI(endDate)}`)
        .then((response) => {
          commit('setCurrentEco', response.data)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Financial Economii Items for current month failed!', 1500);
        })
    },
    getCurrentMonth ({ commit }, obj) {
      const currentMonth = format(obj.date, 'MM')
      const currentYear = format(obj.date, 'yyyy')
      const startDate = new Date(`${currentYear}-${currentMonth}-01 00:00:00`)
      const endDate = endOfMonth(startDate)
      // const startDate = startDate1.clone().startOf('month').format('YYYY-MM-DD HH:mm:ss').toString()
      // const endDate = startDate1.clone().endOf('month').format('YYYY-MM-DD HH:mm:ss').toString()

      const linkFiRows = `${ADD_URL}?fromDate=${encodeURI(format(startDate,'yyyy-MM-dd').toString())}&endDate=${encodeURI(format(endDate,'yyyy-MM-dd').toString())}`
      setTimeout(() => {
        axios.all([
          axios.get(`${linkFiRows}`),
          axios.get(`${RECURRING_URL}`),
          axios.get(`${FIRECANNUALLY_URL}?year=${currentYear}`)
        ])
          .then(axios.spread((fiRows, rec, recAnnually) => {
            commit('setCurrentMonth', fiRows.data)
            commit('setCurrentRecurrency', {
              rec: rec.data, financialRows: fiRows.data, annuallyPaid:recAnnually.data,
              startDate, endDate
            });

          })).catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Financial Items for current month or Recurrences failed!', 1500);
        })
        // axios.get(`${ADD_URL}?fromDate=${encodeURI(startDate.format('YYYY-MM-DD').toString())}&endDate=${encodeURI(endDate.format('YYYY-MM-DD').toString())}`)
        //   .then((response) => {
        //     commit('setCurrentMonth', response.data)
        //   })
        //   .catch((err) => {
        //     // eslint-disable-next-line
        //     miniToastr.error(err.response.data.errorMessage, 'Get Financial Items for current month failed!', 1500);
        //   })
      }, 2000)
    },
    add ({ commit }, obj) {
      let financialUrl = ADD_URL
      if (obj.recurrent_item != '') {
        financialUrl += `?add_recurrent_item=${obj.recurrent_item}`
      }
      axios.post(financialUrl, obj.payload)
        .then((response) => {
          commit('setItem', response.data)
          // eslint-disable-next-line
          miniToastr.success('Added Financial Row', '', 1500);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Financial row failed!', 1500);
        })
    },
    addEco ({ commit }, payload) {
      axios.post(FIECO_URL, payload)
        .then((response) => {
          commit('setItemEco', response.data)
          // eslint-disable-next-line
          miniToastr.success('Added Financial Economii Row', '', 1500);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Financial row failed!', 1500);
        })
    },

    edit ({ commit }, obj) {
      let financialUrl = `${ADD_URL}`;
      let oldRecId = obj.oldItem.recurrent_item ?? '';

      if (obj.recurrent_item != '' && oldRecId != '' && obj.recurrent_item != oldRecId) {
        financialUrl += `?add_recurrent_item=${obj.recurrent_item}&remove_recurrent_item=${oldRecId}`
      } else if (obj.recurrent_item != '' && oldRecId == '') {
        financialUrl += `?add_recurrent_item=${obj.recurrent_item}`
      } else if (obj.recurrent_item == '' && oldRecId != '') {
        financialUrl += `?remove_recurrent_item=${oldRecId}`
      }

      axios.put(financialUrl, obj.payload, { params: { id: obj.payload.id } })
        .then((response) => {
          commit('editItem', { item: response.data, oldItem: obj.oldItem,
            newRecItem: obj.recurrent_item,
            newRecType: obj.recurrent_type
          })
          EventBus.$emit('close-modal')
          miniToastr.success('Edited Financial Row', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Edit Financial row failed!', 1500);
        })
    },
    editEco ({ commit }, obj) {
      axios.put(FIECO_URL, obj.payload, { params: { id: obj.payload.id } })
        .then((response) => {
          commit('editItemEco', { item: response.data, oldItem: obj.oldItem })
          miniToastr.success('Edited Financial Economii Row', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Edit Financial Economii row failed!', 1500);
        })
    },
    getBudgets ({ commit }) {
      axios.get(`${BUDGET_URL}`)
        .then((response) => {
          commit('setBudgets', response.data)
        })
    },
    getBudgetData ({ commit }, obj) {
      const currentMonth = format(new Date(obj.date), 'MM')
      const currentYear = format(new Date(obj.date), 'yyyy')
      const startDate = new Date(`${currentYear}-${currentMonth}-01 00:00:00`)
      const endDate = endOfMonth(startDate)

      axios.all([
        axios.get(`${API_URL}api/per/fitable?fromDate=${encodeURI(format(startDate,'yyyy-MM-dd').toString())}&endDate=${encodeURI(format(endDate,'yyyy-MM-dd').toString())}`), // or direct the axios request
        axios.get(`${BUDGET_URL}`)
      ])
        .then(axios.spread((firstResponse, secondResponse) => {
          commit('setStats', firstResponse.data)
          commit('setBudgetData', secondResponse.data)
        }))
    },
    addPlanning ({ commit }, payload) {
      axios.post(PLANNING_URL, payload)
        .then((response) => {
          commit('setPlanning', response.data)
          // eslint-disable-next-line
          miniToastr.success('Added Planning', '', 1500);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Planning failed!', 1500);
        })
    },
    editPlanning ({ commit }, obj) {
      axios.put(PLANNING_URL, obj.payload, { params: { id: obj.payload.id } })
        .then((response) => {
          commit('editPlanning', { item: response.data, oldItem: obj.oldItem })
          // eslint-disable-next-line
          miniToastr.success('Edited Planning', '', 1500);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Edit Planning failed!', 1500);
        })
    },
    getPlanning ({ commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      axios.all([
        axios.get(`${PLANNING_URL}?offset=${offset}&limit=${limit}&year=${opts.year}`),
        axios.get(GET_URL)
      ])
        .then(axios.spread((planning, cats) => {
          commit('setCat', cats.data)
          // do something with both responses
          commit('setPlannings', planning.data)
        })).catch((err) => {
        // eslint-disable-next-line
        miniToastr.error(err.response.data.errorMessage, 'Get Plannings or Cat failed!', 1500);
        })
    },
    getPlanningDone ({ commit }, year) {
      const currentMonth = format(new Date(),'MM')
      const dateStart = `${year}-${currentMonth}-01`
      // const dateEnd = moment(`${year}-${currentMonth}-01T00:00:00`).endOf('month').format('YYYY-MM-DD')
      const dateEnd = format(endOfMonth(new Date(`${year}-${currentMonth}-01T00:00:00`)), 'yyyy-MM-dd')
      // console.log(moment(`${this.year}-${this.month}-01T00:00:01`););
      axios.get(`${PLANNING_URL}done?date_start=${dateStart}&date_end=${dateEnd}`)
        .then((response) => {
          commit('setPlanningDone', response.data)
        }).catch((err) => {
        // eslint-disable-next-line
        miniToastr.error(err.response.data.errorMessage, 'Get Plannings Done failed!', 1500);
        })
    },
    getPlanningNext ({ commit }, year) {
      const currentMonth = format(new Date(),'MM')
      const dateStart = `${year}-${currentMonth}-01`
      let aa = parseInt(currentMonth, 10)
      if (currentMonth !== '12') {
        aa += 1
      }
      if (aa < 10) {
        aa = `0${aa}`
      }
      const dateEnd = format(endOfMonth(new Date(`${year}-${aa}-01T00:00:00`)), 'yyyy-MM-dd')
      // const dateEnd = moment(`${year}-${aa}-01T00:00:00`).endOf('month').format('YYYY-MM-DD')
      axios.get(`${PLANNING_URL}next?date_start=${dateStart}&date_end=${dateEnd}`)
        .then((response) => {
          commit('setPlanningNext', response.data)
        }).catch((err) => {
        // eslint-disable-next-line
        miniToastr.error(err.response.data.errorMessage, 'Get Plannings Next failed!', 1500);
        })
    },
    // eslint-disable-next-line
    getRecurrences ({ commit, rootState }) {
      let recurringUrl = `${RECURRING_URL}`;

      axios.get(`${recurringUrl}`)
        .then((response) => {
          commit('setRecurrency', response.data)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Get Financial Recurrences failed!', 1500)
        })
    },
    getAvailableRecurrences ({ commit }, opts) {
      commit('setAvailableRecurrency', opts);
    },
    // eslint-disable-next-line
    editRecurrency({commit, rootState}, payload) {
      // eslint-disable-next-line
      axios.put(`${RECURRING_URL}`, payload, { params: { id: payload.id }})
        .then(() => {
          EventBus.$emit('close-modal')
          miniToastr.success('Edited Recurrency!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Recurrency failed!', 1500)
        })
    },
    // eslint-disable-next-line
    addRecurrency({commit, rootState}, payload) {
      // eslint-disable-next-line
      axios.post(`${RECURRING_URL}`, payload)
        .then((response) => {
          commit('addRecurrency', response.data)
          miniToastr.success('Added Recurrency!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Recurrency failed!', 1500)
        })
    },
    // eslint-disable-next-line
    getRecTypes({commit}, opts) {
      commit('setRecTypes', opts);

    },
    // eslint-disable-next-line
    editCat({commit}, payload) {
      // eslint-disable-next-line
      axios.put(`${GET_URL}`, payload, { params: { id: payload.id }})
        .then(() => {
          EventBus.$emit('close-modal')
          miniToastr.success('Edited Category Financial!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Category Financial failed!', 1500)
        })
    },
    addCat({commit}, payload) {
      // eslint-disable-next-line
      axios.post(`${GET_URL}`, payload)
        .then((response) => {
          commit('addCatFinancial', response.data)
          miniToastr.success('Added Category Financial!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Category Financial failed!', 1500)
        })
    },
  },
  getters: {}
}
